import { render, staticRenderFns } from "./Oldpile.vue?vue&type=template&id=c99f2090&"
import script from "./Oldpile.vue?vue&type=script&lang=js&"
export * from "./Oldpile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports